import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { CommandeClient } from "../../models/commande-client.model";
import { CommandeClientFacadeService } from "./commande-client-facade.service";

@Injectable({ providedIn: "root" })
export class CommandeClientStoreService extends EntityStoreService<
  CommandeClient,
  EntityMetadata,
  CommandeClientState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      commandeClient: null,
    });
  }
}

export interface CommandeClientState
  extends EntityStoreState<CommandeClientFacadeService> {
  commandeClient: CommandeClient;
}
